import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { handleTemperaturePeriodSelect, handleTemperatureSelect } from '../../redux/actions/siteSettingsActions';
import ViewHeader from '../viewHeader/viewHeader';
import Thermometer from './thermometer/thermometer';
import './temperaturePicker.scss';

const periods = {
  spring: {},
  summer: {},
  autumn: {},
  winter: {},
}

const temperatures = {
  warm: {
    value: 95,
    min: 25, 
  },
  medium: {
    value: 60,
    min: 20,
    max: 25,
  },
  cool: {
    value: 35,
    max: 20,
  },
}

const TemperaturePicker = ({
  temperaturePeriod,
  temperature,
  onHandleTemperaturePeriodSelect,
  onHandleTemperatureSelect,
  labels,
}) => {
  const renderPeriodButtons = () => (
    Object.keys(periods).map((periodKey) => {
      const periodIsActive = temperaturePeriod === periodKey;
      return (
        <div
          role='button'
          tabIndex="0"
          key={periodKey}
          className={`vf-filter-option ${periodIsActive ? 'vf-filter-option--active' : ''}`}
          onClick={() => { onHandleTemperaturePeriodSelect(periodKey) }}
          onKeyDown={(e) => {
            if (e.keycode === 13) {
              onHandleTemperaturePeriodSelect(periodKey);
            }
          }}>
          <button
            type='button'
            className='vf-filter-option__button'
            data-test={`${periodKey}-button${periodIsActive ? '-selected':''}`}>
              {labels[`traitTemperature_${periodKey}`]}
            </button>
        </div>
      )
    })
  )

  const renderTemperatureButtons = () => (
    Object.keys(temperatures).map((tempKey) => {
      const tempTypeActive = temperature === tempKey;
      return (
        <div
          role='button'
          tabIndex="0"
          key={tempKey}
          onClick={() => { onHandleTemperatureSelect(tempKey) }}
          onKeyDown={(e) => {
            if (e.keycode === 13) {
              onHandleTemperatureSelect(tempKey);
            }
          }}
          className={`vf-filter-option ${tempTypeActive ? 'vf-filter-option--active' : ''}`}>
          <button
            type='button'
            className='vf-filter-option__button'
            data-test={`${tempKey}-button${tempTypeActive ? '-selected':''}`}>
              {labels[`traitTemperature_${tempKey}`]}
            </button>
        </div>
      )
    })
  )

  return (
    <div className="vf-view vf-temperature-picker">
      <ViewHeader header={labels.traitTemperatureHeader} />


      <p className='vf-temperature-picker__sub-header'>{labels.traitTemperatureSeasonSubHeader}</p>
      <section className='vf-temperature-picker__period-container'> 
        { renderPeriodButtons() }
      </section>
      
      <section className='vf-temperature-picker__temperature-wrapper'>
        <p className='vf-temperature-picker__sub-header'>{labels.traitTemperatureSubHeader}</p>
        
        <div className='temperature-container'>
          <div className='temperature-container__buttons-container'>
            { renderTemperatureButtons() }
          </div>

          <Thermometer temperature={temperatures[temperature]} />
        </div>
      </section>

    </div>
  )
}

TemperaturePicker.propTypes = {
  temperaturePeriod: PropTypes.string,
  temperature: PropTypes.string,
  onHandleTemperaturePeriodSelect: PropTypes.func.isRequired,
  onHandleTemperatureSelect: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    traitTemperatureHeader: PropTypes.string.isRequired,
    traitTemperatureSeasonSubHeader: PropTypes.string.isRequired,
    traitTemperatureSubHeader: PropTypes.string.isRequired,
    traitTemperature_spring: PropTypes.string.isRequired,
    traitTemperature_summer: PropTypes.string.isRequired,
    traitTemperature_autumn: PropTypes.string.isRequired,
    traitTemperature_winter: PropTypes.string.isRequired,
    traitTemperature_cool: PropTypes.string.isRequired,
    traitTemperature_medium: PropTypes.string.isRequired,
    traitTemperature_warm: PropTypes.string.isRequired,
  }).isRequired,
};

TemperaturePicker.defaultProps = {
  temperaturePeriod: null,
  temperature: null,
};

const mapStateToProps = ({ siteSettings, attributeCollection }) => {
  const labels = {
    traitTemperatureHeader: attributeCollection.traitTemperatureHeader,
    traitTemperatureSeasonSubHeader: attributeCollection.traitTemperatureSeasonSubHeader,
    traitTemperatureSubHeader: attributeCollection.traitTemperatureSubHeader,
    traitTemperature_spring: attributeCollection.traitTemperature_spring,
    traitTemperature_summer: attributeCollection.traitTemperature_summer,
    traitTemperature_autumn: attributeCollection.traitTemperature_autumn,
    traitTemperature_winter: attributeCollection.traitTemperature_winter,
    traitTemperature_cool: attributeCollection.traitTemperature_cool,
    traitTemperature_medium: attributeCollection.traitTemperature_medium,
    traitTemperature_warm: attributeCollection.traitTemperature_warm,
  }

  return {
    temperature: siteSettings.filters.selectedTemperature,
    temperaturePeriod: siteSettings.filters.selectedTemperaturePeriod,
    labels,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onHandleTemperaturePeriodSelect: (temperaturePeriod) => {
      dispatch(handleTemperaturePeriodSelect(temperaturePeriod));
    },
    onHandleTemperatureSelect: (temperature) => {
      dispatch(handleTemperatureSelect(temperature));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemperaturePicker);